import React, { useState } from "react";
import TypewriterEffect from "./TypewriterEffectPlayerProfile";
import "../css/LandingPage.css";
import box_icon_1 from '../assets/Search.png';
import box_icon_2 from '../assets/Message Bot.png';
import box_icon_3 from '../assets/Analytics.png';
import cavan_sullivan from '../assets/cavan_sullivan.jpg';
import { Link } from "react-router-dom";

const LandingPage = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [clickedIndex, setClickedIndex] = useState('');
  const [featureSection, setFeatureSection] = useState(true);

  const players = [
    {
      name: 'Cavan Sullivan',
      club: 'Philadelphia Union',
      image: cavan_sullivan, // Replace with actual image paths
      badge: 'https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/philadelphia-union.png', // Replace with actual badge paths
    },
    {
      name: 'Jude Wellings',
      club: 'Real Salt Lake',
      image: 'https://www.goldcleats.com/gc-content/uploads/avatars/108744/MTA4NzQ01641071210-bpfull.jpg',
      badge: 'https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/real-salt-lake-city.png',
    },
    {
      name: 'Nimfasha Berchimas',
      club: 'Charlotte FC',
      image: 'https://www.goldcleats.com/gc-content/uploads/avatars/112859/MTEyODU51647395829-bpfull.jpg',
      badge: 'https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/Charlotte_FC.png',
    },
    {
      name: 'Alex Alcalá',
      club: 'Manchester City',
      image: 'https://www.goldcleats.com/gc-content/uploads/avatars/113016/MTEzMDE21650399700-bpfull.jpg',
      badge: 'https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/manchester_city_fc.png',
    },
  ];


  // Handle suggestion click event
  const handleClickSuggestions = (event, index) => {
    event.preventDefault(); // Prevent the default anchor tag behavior    
    //console.log(isLoading + index);
    // if (isLoading) {
    //   return;
    // }

    setClickedIndex(index)
    setFeatureSection(false)
  };


  return (
    <div className="landing-page-container">
      {/* Header Section */}
      <header className="header">
        <h1 className="title">Try The Smartest Soccer AI</h1>
        <p className="subtitle">
          Check out our players profile and see the AI results powered by The GoldCleats Player Video Library.
        </p>

        <div className="row justify-content-center player-showcase">
          {players.map((player, index) => (
            <div key={index} className="col-md-3 col-sm-12 mb-3" onClick={(event) => handleClickSuggestions(event, index)}>
              <div className="card bg-dark text-light border-0 shadow-sm">
                <div className="card-body d-flex align-items-center">
                  <img
                    src={player.image}
                    alt={`${player.name}`}
                    className="square-corner me-3"
                    style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                  />
                  <div className="mr-8">
                    <div className="mb-0 player-name">{player.name} <img src="https://cdn.goldcleats.com/UI/img/ic_verified_blue.png" alt="Verified" style={{ width: '16px', marginLeft: '5px' }} /></div>
                    <p className="club-name mb-0">{player.club}</p>
                  </div>
                  <img
                    src={player.badge}
                    alt="Club Badge"
                    className="ms-auto"
                    style={{ width: '44px', height: '44px' }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

      </header>

      <TypewriterEffect setIsLoading={setIsLoading} clickedIndex={clickedIndex} />


      {/* Features Section */}
      {featureSection &&
        <section className="features-section-container mt-5">
          <div className="features">
            <div className="feature">
              <img width={50} src={box_icon_1} loading="lazy" alt="" />
              <h3>Player Discovery</h3>
              <p>
                Explore talented players from around the globe with advanced AI recommendations.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={box_icon_2} loading="lazy" alt="" />
              <h3>AI-Driven Insights</h3>
              <p>
                Gain deep insights into player performance metrics and comparisons.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={box_icon_3} loading="lazy" alt="" />
              <h3>Advanced Analytics</h3>
              <p>
                Leverage data-driven decisions to make smarter soccer scouting choices.
              </p>
            </div>
          </div>
        </section>
      }



      {/* Media Section */}
      {/* <section className="media-section">
        <h3>Community Members Who Signed Pro Contracts</h3>
        <VerifiedUsersCarousel />
      </section> */}


      {/* Login Button */}
      {featureSection &&
        <footer className="footer">
          <Link className="nav-link btn btn-login" to="/login">
            Login to Explore
          </Link>

        </footer>
      }
    </div>
  );
};

export default LandingPage;
